import { Alert, Heading } from '@livechat/design-system-react-components'

import { alertWrapperCss } from './styles'

const CannotBuyAlert = () => (
  <Alert kind="warning" data-test="cannot-purchase-info" css={alertWrapperCss}>
    <Heading size="xs">Sorry, you can’t buy apps</Heading>
    You can add this app to cart instead. We’ll let your subscription admins
    know about your purchase request.
  </Alert>
)

export default CannotBuyAlert
